module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-photo-0f0f72d0bb5dd06108ee529e3365d241.png";